import {isNil} from 'ramda';

import {AdServer} from '../../../types/AdServer';
import {FiltersRequestBody, GetAdvertisementServerLinkApiArg} from '../../../types/api/api';

export function getAdServerRequestArg(params: {
  filter: FiltersRequestBody | null;
  priceReportId: string;
  adServer: AdServer;
  isMultiServers: boolean;
}): GetAdvertisementServerLinkApiArg | null {
  return isNil(params.filter)
    ? null
    : {
        id: params.priceReportId,
        body: {...params.filter, server: params.isMultiServers ? params.adServer : undefined},
      };
}
